// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const useLineClampFitStyle = require('client-v2/common/hooks/line-clamp')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ContentAddModalArticlePreview')

function ContentAddModalArticlePreview({
  // Flags
  isArticleFailed,
  isArticleLoading,
  // Values
  article,
  className,
  url,
  // Callbacks
  onRetryClick
}) {
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag(ContentAddModalArticlePreviewDetails, { article }),
      (
        isArticleFailed
        ? tag(ContentAddModalArticlePreviewError, { url, onRetryClick })
        : tag('div', {
          className: bem.element('article-placeholder', {
            visible: !article,
            loading: isArticleLoading
          })
        })
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  ContentAddModalArticlePreview.propTypes = {
    // Flags
    isArticleLoading: PropTypes.bool,
    isArticleFailed: PropTypes.bool,
    // Values
    article: PropTypes.shape(ArticleModelRecord.propTypes),
    className: PropTypes.string,
    url: PropTypes.string,
    // Callbacks
    onRetryClick: PropTypes.func
  }
}

module.exports = ContentAddModalArticlePreview

function ContentAddModalArticlePreviewDetails({ article }) {
  const titleRef = React.useRef()
  const titleStyle = useLineClampFitStyle({ domRef: titleRef })
  const descriptionRef = React.useRef()
  const descriptionStyle = useLineClampFitStyle({ domRef: descriptionRef })
  return (
    tag('div', {
      className: bem.element('article-wrapper', {
        visible: !!article
      })
    },
      article && (
        tag('div', {
          className: bem.element('article-details')
        },
          tag(LazyImage, {
            className: bem.element('article-image'),
            sources: [ article.md5image, article.image ]
          }),
          tag('div', {
            className: bem.element('details')
          },
            tag('div', {
              className: bem.element('domain')
            },
              article.hostname
            ),
            tag('div', {
              ref: titleRef,
              className: bem.element('title'),
              style: titleStyle
            },
              article.title
            ),
            tag('div', {
              ref: descriptionRef,
              className: bem.element('description'),
              style: descriptionStyle
            },
              article.description
            )
          )
        )
      )
    )
  )
}

function ContentAddModalArticlePreviewError({ onRetryClick }) {
  return (
    tag('div', {
      className: bem.element('article-error')
    },
      tag('p', {
        className: bem.element('error-heading')
      },
        'Oops.'
      ),
      tag('p', {
        className: bem.element('error-subheading')
      },
        'We couldn’t gather the information from this website.',
        tag('br'),
        'Please double-check your link or try again later.'
      ),
      tag(CapsuleButton, {
        className: bem.element('error-button'),
        onClick: onRetryClick
      },
        'Retry'
      ),
      tag(CapsuleButton, {
        className: bem.element('error-button'),
        href: 'mailto:support@mix.com'
      },
        'Contact Support'
      )
    )
  )
}
